import { WagmiProvider } from "wagmi";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { PropsWithChildren } from "react";
import { createSyncAdapter } from "@latticexyz/store-sync/internal";
import { SyncProvider } from "@latticexyz/store-sync/react";
import { stash } from "./mud/stash";
import { defineConfig, EntryKitProvider } from "@latticexyz/entrykit/internal";
import { wagmiConfig } from "./wagmiConfig";
import { chainId, getWorldAddress, startBlock } from "./common";
import { RoleProvider } from "./context/role";

const queryClient = new QueryClient();

export function Providers({ children }: PropsWithChildren) {
  const worldAddress = getWorldAddress();
  return (
    <RoleProvider>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <EntryKitProvider config={defineConfig({ chainId, worldAddress })}>
            <SyncProvider
              chainId={chainId}
              address={worldAddress}
              startBlock={startBlock}
              indexerUrl={false}
              adapter={createSyncAdapter({ stash })}
            >
              {children}
            </SyncProvider>
          </EntryKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </RoleProvider>
  );
}
